// 获取用户答案
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { E_QUIZ_ANSWER_RIGHT } from '@umu/umu-types';

export interface IInput {
    element_id: number;
    question_ids: string;
    _type: number; // 新老考试的区分
}

export const getUserAnswerResult = (data: IInput): Promise<Record<string, E_QUIZ_ANSWER_RIGHT>> => {
    return fetchData(Api.GET_USER_QUIZ_RIGHT_RESULT, data)
        .then((res: IResponse<Record<string, E_QUIZ_ANSWER_RIGHT>>) => {
            return res.data || {};
        })
        .catch(() => {
            return {};
        });
};
